import addError from '../../../utils/error.jsx';
import { fromJS, Map } from 'immutable';

export function request(state, action) {
    return state
        .set(
            'create',
            Map({
                errors: undefined,
                state: 'IN_PROGRESS'
            })
        );
}

export function error(state, { errors }) {
    addError(Object.keys(errors).map(key => errors[key]));

    return state
        .set(
            'create',
            Map({
                errors: fromJS(errors),
                state: 'ERROR'
            })
        );
}

export function finish(state, action) {
    return state
        .set(
            'create',
            Map({
                id: action.event.id,
                errors: undefined,
                state: 'FINISHED'
            })
        );
}
